import moment from 'moment-timezone'
import { getIso2FromIso3 } from '../utils'
import { SettingsManager, SiteConfigManager } from '..'

const DEFAULT_DATE_FORMAT = 'DD.MM'
const DEFAULT_TIME_FORMAT = 'HH:mm'

const DATE_FORMAT_TYPES = {
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year'
}

export function modifyMoment (parsedTime, { type, value }) {
  const changedDate = parsedTime.clone()

  switch (type) {
    case DATE_FORMAT_TYPES.DAY:
      changedDate.date(value)
      break
    case DATE_FORMAT_TYPES.MONTH:
      changedDate.month(value)
      break
    case DATE_FORMAT_TYPES.YEAR:
      changedDate.year(value)
      break
  }

  return changedDate
}

export function toDate (momentDate) {
  return moment(momentDate, DEFAULT_DATE_FORMAT).toDate()
}

export function toTime (momentDate) {
  return moment(momentDate, DEFAULT_DATE_FORMAT).valueOf()
}

export function toMoment (timestamp) {
  return moment(timestamp)
}

export function parse (date, format = DEFAULT_DATE_FORMAT) {
  return date
    ? moment(date, format)
    : moment()
}

export function format (time) {
  if (moment.isMoment(time)) {
    return time.format(DEFAULT_DATE_FORMAT)
  } else {
    return moment(time).format(DEFAULT_DATE_FORMAT)
  }
}

export function getTimeDifference (beginTime, endTime, unitOfTime) {
  return moment(beginTime).diff(endTime, unitOfTime)
}

export const getFormattedDate = utcDate => {
  const lang = SettingsManager.settings.lang
  const dateFormat = SiteConfigManager.getConfig('config.config.date.dateFormat', DEFAULT_DATE_FORMAT)
  const date = moment(utcDate)
  return date.locale(getIso2FromIso3(lang) || 'en')
    .format(dateFormat)
}

export const getFormattedTime = (utcDate, simpleTime = null) => {
  const lang = SettingsManager.settings.lang
  const timeFormat = simpleTime
    ? SiteConfigManager.getConfig('config.config.date.simpleTimeFormat', DEFAULT_TIME_FORMAT)
    : SiteConfigManager.getConfig('config.config.date.timeFormat', DEFAULT_TIME_FORMAT)

  // Let Browser manage locale/timezone
  // const date = timeFormat.endsWith('z')
  //   ? moment.tz(utcDate, 'Australia/Sydney')
  //   : moment(utcDate)

  const date = moment(utcDate)
  return date
    .locale(getIso2FromIso3(lang) || 'en')
    .format(timeFormat)
}

export const getFormattedDateWithTime = (utcDate, simpleTime = null) => {
  const lang = SettingsManager.settings.lang
  const dateFormat = SiteConfigManager.getConfig('config.config.date.dateFormat', DEFAULT_DATE_FORMAT)
  const timeFormat = simpleTime
    ? SiteConfigManager.getConfig('config.config.date.simpleTimeFormat', DEFAULT_TIME_FORMAT)
    : SiteConfigManager.getConfig('config.config.date.timeFormat', DEFAULT_TIME_FORMAT)

  // Let Browser manage locale/timezone
  // const date = timeFormat.endsWith('z')
  //   ? moment.tz(utcDate, 'Australia/Sydney')
  //   : moment(utcDate)

  const date = moment(utcDate)
  return date
    .locale(getIso2FromIso3(lang) || 'en')
    .format(`${dateFormat} ${timeFormat}`)
}
